import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BookTable from "../BookTable";
import PostCardTable from "../PostCardTable";
import AdminLayout from "../component/AdminLayout";
import { getAdminAuthorInfo, updateAuthorStatus } from "../../../api";
import RejectReasonModal from "../../../common/layouts/modal/RejectReasonModal";

interface updateMap {
    authorEmail?: string;
    authorStatus?: string;
}
const AdminDetail = () => {

    const location = useLocation();

    const [authors, setAuthors] = useState<any>(null); // 작가 목록 상태 추가
    const [naverLink, setNaverLink] = useState('');
    const [xlink, setXlink] = useState('');
    const [brunchLink, setBrunchLink] = useState('');
    const [instagramLink, setInstagramLink] = useState('');
    const [profile, setProfile] = useState('');

    const [editing, setEditing] = useState(false);
    const [status, setStatus] = useState('')
    const [showRejectModal, setShowRejectModal] = useState(false);

    const [snsLink1, setSnsLink1] = useState('');
    const [snsLink2, setSnsLink2] = useState('');
    const [bookTitle, setBookTitle] = useState('');
    const [bookLink, setBookLink] = useState('');

    const [bookList, setBookList] = useState([]);
    const [postcardList, setPostcardList] = useState([]);



    const handleStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setStatus(event.target.value);
    };
    let email = location.state.author.authorEmail;

    const handleSave = async () => {
        try {
            if (authors.accountStatus === 'ACTIVE' && status === 'SUSPENDED') {
                alert("이미 승인 완료된 작가는 반려 처리할 수 없습니다.");
                return;
            }
            if (status === 'SUSPENDED' && authors.accountStatus !== 'PENDING' && authors.accountStatus !== 'SUSPENDED') {
                alert("작가 신청이 진행 중(승인 대기)인 사람만 반려 처리가 가능합니다.");
                return;
            }

            if (status === 'SUSPENDED') {
                setShowRejectModal(true);
                return;
            }

            const confirmSave = window.confirm("작가 상태를 변경하시겠습니까?");
            if (!confirmSave) return;

            await updateAuthorStatus(email, status);

            setEditing(false);

            setAuthors((prevAuthors: any) => ({
                ...prevAuthors,
                accountStatus: status // 서버에 보낸 새 상태값으로 덮어씌움
            }));

            getList();

            alert("작가 상태를 변경했습니다.");
        } catch (error) {
            console.error('Error updating data:', error);
            alert("상태 변경에 실패했습니다.");
        }
    };


    const authorTargetParam = {
        authorEmail: email
    };

    useEffect(() => {
        // Check if status is HOLD or author status is HOLD from passed state
        const passedStatus = location.state?.status;
        const passedAuthor = location.state?.author;

        if (passedStatus === 'HOLD' || passedAuthor?.accountStatus === 'HOLD') {
            if (passedAuthor) {
                console.log("Using passed data for HOLD author:", passedAuthor);

                const data = passedAuthor;

                // Populate state from passed data
                setBookList(data.bookList || []);
                setPostcardList(data.postcardList || []);

                setNaverLink(data.naverLink || '-');
                setXlink(data.xlink || '-');
                setBrunchLink(data.brunchLink || '-');
                setInstagramLink(data.instagramLink || '-');
                setSnsLink1(data.snsLink1 || '');
                setSnsLink2(data.snsLink2 || '');
                setBookTitle(data.representativeBookTitle || '등록된 도서 없음');
                setBookLink(data.representativeBookLink || '#');

                setAuthors(data);
                setProfile(data.profilePhoto ? `data:image/jpeg;base64,${data.profilePhoto}` : '');
                setStatus(data.accountStatus);
            }
        } else {
            // Active or other statuses, fetch fresh data from API
            getList();
        }

    }, [])

    async function getList() {
        try {
            const responseData = await getAdminAuthorInfo(email);

            const data = responseData.author;
            //console.log("responseData:::::::::::::", responseData)

            setBookList(responseData.bookList)
            setPostcardList(responseData.postcardList || [])

            setNaverLink(data.naverLink || '-');
            setXlink(data.xlink || '-');
            setBrunchLink(data.brunchLink || '-');
            setInstagramLink(data.instagramLink || '-');
            setSnsLink1(data.snsLink1 || '');
            setSnsLink2(data.snsLink2 || '');
            setBookTitle(data.representativeBookTitle || '등록된 도서 없음');
            setBookLink(data.representativeBookLink || '#');

            setAuthors(data);
            setProfile(`data:image/jpeg;base64,${data.profilePhoto}`)
            setStatus(data.accountStatus);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    if (authors === null) {
        return <p>Loading...</p>;
    }

    const statusMapping: { [key: string]: string } = {
        "PENDING": "승인 대기",
        "ACTIVE": "활성화",
        "SUSPENDED": "반려",
        "HOLD": "비활성화",
    };


    return (
        <AdminLayout
            pageTitle="작가 관리"
            breadcrumbs={[
                { label: 'Home', link: '/admin' },
                { label: 'View', active: true }
            ]}
        >
            {/* [ Main Content ] start */}
            <div className="main-content">
                <div className="row g-4">

                    {/* 왼쪽 프로필 카드 (3/12 비율로 축소하여 공간 확보) */}
                    <div className="col-xxl-3 col-xl-4">
                        <div className="card border border-[#f1f5f9] shadow-sm rounded-[16px] h-100">
                            <div className="card-body p-4 text-center">
                                <div
                                    className="wd-150 ht-150 mx-auto mb-3 border border-4 border-light rounded-circle shadow-sm overflow-hidden">
                                    <img src={profile} alt="Profile" className="w-100 h-100 object-fit-cover" />
                                </div>
                                <h5 className="fw-bold mb-1 text-dark">{authors.authorName}</h5>
                                <p className="text-muted fs-13 mb-4">{authors.authorEmail}</p>

                                <ul className="list-unstyled text-start mb-4">
                                    <li className="d-flex justify-content-between align-items-center mb-3">
                                        <span className="text-muted fs-13 fw-medium">상태</span>
                                        {editing ? (
                                            <select
                                                className="form-select border-2 shadow-none w-auto cursor-pointer"
                                                style={{
                                                    borderColor: '#e2e8f0',
                                                    minWidth: '140px',
                                                    fontSize: '0.875rem',
                                                    fontWeight: '500',
                                                    padding: '0.4rem 2rem 0.4rem 0.8rem',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#fff',
                                                    transition: 'all 0.2s'
                                                }}
                                                value={status}
                                                onChange={handleStatusChange}
                                                onFocus={(e) => e.target.style.borderColor = '#6366f1'} // 포커스 시에만 강조
                                                onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                                            >
                                                {authors.accountStatus === 'PENDING' && (
                                                    <>
                                                        <option value="PENDING">승인 대기</option>
                                                        <option value="ACTIVE">활성화 (승인)</option>
                                                        <option value="SUSPENDED">반려</option>
                                                    </>
                                                )}
                                                {authors.accountStatus === 'ACTIVE' && (
                                                    <>
                                                        <option value="ACTIVE">활성화</option>
                                                        <option value="HOLD">비활성화</option>
                                                    </>
                                                )}
                                                {authors.accountStatus === 'HOLD' && (
                                                    <>
                                                        <option value="HOLD">비활성화</option>
                                                        <option value="ACTIVE">활성화</option>
                                                    </>
                                                )}
                                                {authors.accountStatus === 'SUSPENDED' && (
                                                    <>
                                                        <option value="SUSPENDED">반려</option>
                                                        <option value="PENDING">승인 대기 (재심사)</option>
                                                    </>
                                                )}
                                            </select>
                                        ) : (
                                            <span className="badge px-3 py-2 rounded-pill border-0 fw-bold" style={{
                                                backgroundColor: authors.accountStatus === 'ACTIVE' ? '#ecfdf5' :
                                                                 authors.accountStatus === 'PENDING' ? '#fffbeb' :
                                                                 authors.accountStatus === 'SUSPENDED' ? '#fef2f2' : '#f1f5f9',
                                                color: authors.accountStatus === 'ACTIVE' ? '#10b981' :
                                                       authors.accountStatus === 'PENDING' ? '#f59e0b' :
                                                       authors.accountStatus === 'SUSPENDED' ? '#ef4444' : '#64748b'
                                            }}>
                                                {statusMapping[authors.accountStatus]}
                                            </span>
                                        )}
                                    </li>
                                    <hr className="opacity-50" />
                                    <p className="fs-11 fw-bold text-muted text-uppercase mb-3">Social Links</p>
                                    {[
                                        { label: 'Blog', value: naverLink, icon: 'feather-link' },
                                        { label: 'X', value: xlink, icon: 'feather-twitter' },
                                        { label: 'Brunch', value: brunchLink, icon: 'feather-edit-3' },
                                        { label: 'Instagram', value: instagramLink, icon: 'feather-instagram' }
                                    ].map((sns, i) => (
                                        <li key={i} className="mb-4 d-flex justify-content-between overflow-hidden">
                                            <span className="text-muted fs-12"><i
                                                className={`${sns.icon} me-2`}></i>{sns.label}</span>
                                            <a href={sns.value !== '-' ? sns.value : '#'} target="_blank"
                                                rel="noreferrer"
                                                className="text-primary text-truncate ms-3 fs-12">{sns.value}</a>
                                        </li>
                                    ))}
                                </ul>

                                <button 
                                    className="btn w-100 rounded-[10px] py-2 fw-bold text-[14px]"
                                    style={{
                                        backgroundColor: editing ? '#6366f1' : 'transparent',
                                        borderColor: '#6366f1',
                                        color: editing ? '#fff' : '#6366f1',
                                        borderWidth: '1px',
                                        borderStyle: 'solid'
                                    }}
                                    onClick={() => editing ? handleSave() : setEditing(true)}
                                >
                                    {editing ? '저장하기' : '상태 수정'}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-9 col-xl-8">
                        <div className="card border border-[#f1f5f9] shadow-sm rounded-[16px] overflow-hidden">
                            <div className="card-header p-0 bg-white border-bottom-0">
                                <ul className="nav nav-tabs nav-tabs-custom w-100 text-center" role="tablist">
                                    <li className="nav-item flex-fill">
                                        <a className="nav-link active py-3 fw-bold" data-bs-toggle="tab"
                                            data-bs-target="#overviewTab" role="tab">Overview</a>
                                    </li>
                                    {authors.accountStatus !== 'PENDING' && (
                                        <>
                                            <li className="nav-item flex-fill">
                                                <a className="nav-link py-3 fw-bold"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#billingTab"
                                                    role="tab">
                                                    Book
                                                    {authors.accountStatus === 'HOLD' && <span className="badge bg-soft-danger text-danger ms-2" style={{ fontSize: '10px' }}>비활성</span>}
                                                </a>
                                            </li>
                                            <li className="nav-item flex-fill">
                                                <a className="nav-link py-3 fw-bold"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#activityTab"
                                                    role="tab">
                                                    Postcard
                                                    {authors.accountStatus === 'HOLD' && <span className="badge bg-soft-danger text-danger ms-2" style={{ fontSize: '10px' }}>비활성</span>}
                                                </a>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </div>

                            <div className="card-body p-4">
                                <div className="tab-content">
                                    <div className="tab-pane fade show active" id="overviewTab" role="tabpanel">

                                        {/* 대표작 알림 바 */}
                                        <div
                                            className="alert border border-[#e2e8f0] bg-[#f8fafc] p-4 mb-5 d-flex justify-content-between align-items-center rounded-[12px]">
                                            <div>
                                                <small className="fw-bold text-uppercase" style={{ color: '#6366f1' }}>대표작</small>
                                                <h5 className="fw-bold text-dark mt-1 mb-0">{bookTitle || "등록된 대표작이 없습니다."}</h5>
                                            </div>
                                            <a href={bookLink} target="_blank" rel="noreferrer"
                                                className="btn btn-outline-dark btn-sm rounded-pill px-4">링크 이동</a>
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="fw-bold mb-3 d-flex align-items-center">
                                                <span className="rounded me-2"
                                                    style={{ width: '4px', height: '18px', backgroundColor: '#6366f1' }}></span>작가 소개
                                            </h5>
                                            <p className="border border-[#e2e8f0] bg-[#f8fafc] p-4 rounded-[12px] text-dark lh-base"
                                                style={{ whiteSpace: 'pre-wrap' }}>{authors.authorIntro}</p>
                                        </div>

                                        <div className="mb-5">
                                            <h5 className="fw-bold mb-3 d-flex align-items-center">
                                                <span className="rounded me-2"
                                                    style={{ width: '4px', height: '18px', backgroundColor: '#6366f1' }}></span>상세 설명
                                            </h5>

                                            <div className="author-desc-content border border-[#e2e8f0] rounded-[12px] p-4 bg-white"
                                                dangerouslySetInnerHTML={{ __html: authors.authorDescription }}>
                                            </div>
                                        </div>

                                        <div className="border border-[#e2e8f0] bg-[#f8fafc] p-4 rounded-[12px]">
                                            <div className="row g-4">
                                                <div className="col-md-4">
                                                    <small className="text-muted d-block mb-2">키워드</small>
                                                    <div className="d-flex gap-2">
                                                        {authors.keyword1 && <span
                                                            className="badge bg-white border px-3 py-2 rounded-lg" style={{ color: '#6366f1', borderColor: '#e2e8f0' }}>#{authors.keyword1}</span>}
                                                        {authors.keyword2 && <span
                                                            className="badge bg-white border px-3 py-2 rounded-lg" style={{ color: '#6366f1', borderColor: '#e2e8f0' }}>#{authors.keyword2}</span>}
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <small className="text-muted d-block mb-2">신청 시각</small>
                                                    <span className="fw-bold text-dark">
                                                        {new Date(authors.requestTime).toLocaleString('ko-KR', {
                                                            year: 'numeric',
                                                            month: '2-digit',
                                                            day: '2-digit',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: false
                                                        }).replace(/\./g, '-')}
                                                    </span>
                                                </div>
                                                <div className="col-md-4">
                                                    <small className="text-muted d-block mb-2">대표 도서 링크</small>
                                                    <a href={bookLink}
                                                        className="text-primary text-truncate d-block fw-bold text-[#6366f1] hover:text-[#4f46e5]">{bookLink || '-'}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="tab-pane fade" id="billingTab" role="tabpanel">
                                        {/* bookList props 추가 */}
                                        <BookTable
                                            authorEmail={authors.authorEmail}
                                            bookList={bookList}
                                        />
                                    </div>
                                    <div className="tab-pane fade" id="activityTab" role="tabpanel">
                                        <PostCardTable postList={postcardList} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {showRejectModal && authors && (
                <RejectReasonModal
                    authorName={authors.authorName}
                    authorEmail={authors.authorEmail}
                    onClose={() => setShowRejectModal(false)}
                    onSuccess={() => {
                        setShowRejectModal(false);
                        setEditing(false);
                        setAuthors((prevAuthors: any) => ({
                            ...prevAuthors,
                            accountStatus: 'SUSPENDED'
                        }));
                        getList();
                    }}
                />
            )}
        </AdminLayout>
    )

}

export default AdminDetail;
